import Copyright from "../components/pages/Copyright";

export default [
    {
        path: '/copyright',
        component: Copyright,
        name: 'copyright'
    },
]
